import React from 'react'
import { css } from '@emotion/core'
import { colors, LayoutBand, useContainerWidth, Grid } from '@fs/zion-ui'
import PlaceEditorTrainingHeader from './components/PlaceEditorTrainingHeader'
import PlaceEditorTrainingNav from './components/PlaceEditorTrainingNav'
import PlaceEditorTrainingContent from './components/PlaceEditorTrainingContent'

export default function PlaceEditorTrainingPage() {
  const atWidth = useContainerWidth()
  const isMobile = atWidth({ default: true, lg: false })

  return (
    <LayoutBand
      maxWidth="xxl"
      marginY="nano"
      marginX="nano"
      id="place-editor-training-page"
      css={css`
        height: 100%;
        background: ${colors.gray02};
      `}
    >
      <Grid>
        <PlaceEditorTrainingHeader columns={12} />
        {!isMobile && <PlaceEditorTrainingNav columns={3} />}
        <PlaceEditorTrainingContent columns={isMobile ? 12 : 9} />
      </Grid>
    </LayoutBand>
  )
}
